export default "__VITE_ASSET__DStdwwRD__"